// extracted by mini-css-extract-plugin
module.exports = {"button":"_1EM5l","commentButton":"_3-D83","commentButtonIcon":"_3bMZq","commentButtonContent":"THjMa","followButton":"_1e13F","container":"_2dT1t"};